import React, { useCallback } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AgreementModal from './AgreementModal';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, loading, acceptTerms, logout } = useAuth();

  const onAgreementContinue = useCallback(async () => {
    try {
      await acceptTerms();
    } catch {
      // Error handled by acceptTerms
    }
  }, [acceptTerms]);

  const onAgreementClose = useCallback(() => {
    logout();
  }, [logout]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner w-8 h-8"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // تحقق من السيرفر (Prisma): إذا لم يوافق المستخدم على الشروط بعد — يعمل حتى في WebView/آيفون
  if (user.requiresTermsAcceptance) {
    return (
      <>
        <div className="min-h-screen bg-slate-800 flex items-center justify-center p-4">
          <p className="text-slate-300">جاري التحميل...</p>
        </div>
        <AgreementModal
          isOpen
          onClose={onAgreementClose}
          onContinue={onAgreementContinue}
        />
      </>
    );
  }

  return <>{children}</>;
};

export default PrivateRoute; 